import axios from 'axios';

export const getProducerAttachments = (producerId: string) => {
    return axios.get(`images/attachments/producer/${producerId}`);
};

export const getProductAttachments = (productId: string) => {
    return axios.get(`images/attachments/product/${productId}`);
};

export const getImageById = (imageId: string) => {
    return axios.get(`images/category/${imageId}`);
};

const fetchImage = async (endpoint: string, fileId: string): Promise<string | null> => {
    const response = await axios.get(`images/${endpoint}/${fileId}`, {
        responseType: 'blob',
    });

    if (response.status === 200 && response.data.size > 0) {
        return URL.createObjectURL(response.data);
    } else {
        return null;
    }
};

export const getDimensionedImage = (fileId: string): Promise<string | null> => {
    return fetchImage('GetProductImage', fileId);
};

export const getProductImageUrl = (fileId: string): string => {
    return `${process.env.REACT_APP_BASE_URL}images/GetProductImage/${fileId}`;
};
